import axios from 'axios';
import { API_URL } from '../config';

const login = async (username: string, password: string) => {
  const response = await axios.post(`${API_URL}/auth/login`, {
    username,
    password,
  });
  return response.data;
};

const authService = {
  login,
};

export default authService;